import { Observable } from 'rxjs'
import { Apollo } from 'apollo-angular'
import { Injectable } from '@angular/core'
import {
    SendContactFormMutation,
    SendContactFormMutationService,
    SendContactFormMutationVariables,
} from '@app-graphql/schema'

@Injectable({
    providedIn: 'root',
})
export class ContactService {

    constructor(
        private readonly sendContactFormMutationService: SendContactFormMutationService,
    ) {
    }

    public sendContactForm(input: SendContactFormMutationVariables)
        : Observable<Apollo.MutateResult<SendContactFormMutation>> {
        return this.sendContactFormMutationService.mutate({
            variables: input,
            errorPolicy: 'all',
        })
    }
}
